import axios from 'axios';
import { AUTH_URL } from '../config/apiUrls';
import type {
  Connection,
  ConnectionsOverview,
  CreateConnectionPayload,
  PresenceStatus,
} from '../types/connections';
import { attachAuthInterceptors } from './attachAuthInterceptors';

const connectionsClient = axios.create({
  baseURL: AUTH_URL,
  headers: { 'Content-Type': 'application/json' },
});

attachAuthInterceptors(connectionsClient);

export const connectionsApi = {
  getOverview: async (): Promise<ConnectionsOverview> => {
    const response = await connectionsClient.get<ConnectionsOverview>('/connections');
    return response.data;
  },

  create: async (payload: CreateConnectionPayload): Promise<Connection> => {
    const response = await connectionsClient.post<Connection>('/connections', payload);
    return response.data;
  },

  accept: async (connectionId: number): Promise<Connection> => {
    const response = await connectionsClient.post<Connection>(
      `/connections/${connectionId}/accept`,
    );
    return response.data;
  },

  reject: async (connectionId: number): Promise<Connection> => {
    const response = await connectionsClient.post<Connection>(
      `/connections/${connectionId}/reject`,
    );
    return response.data;
  },

  remove: (connectionId: number) =>
    connectionsClient.delete(`/connections/${connectionId}`),

  updateShareSettings: async (
    connectionId: number,
    payload: import('../types/connections').UpdateConnectionSharePayload,
  ): Promise<Connection> => {
    const response = await connectionsClient.patch<Connection>(
      `/connections/${connectionId}/share`,
      payload,
    );
    return response.data;
  },

  getPresence: async (): Promise<PresenceStatus> => {
    const response = await connectionsClient.get<PresenceStatus>('/presence');
    return response.data;
  },

  setPresence: async (active: boolean): Promise<PresenceStatus> => {
    const response = await connectionsClient.put<PresenceStatus>('/presence', { active });
    return response.data;
  },
};
